module.exports = "https://static.cdns.space/tarot-temp/img/the-lovers.fa4b11f4.webp";